import React from 'react';
import { motion } from 'framer-motion';
import { FaMobileAlt, FaLaptopCode, FaRobot, FaSearchDollar } from 'react-icons/fa';

const Services = () => {
  const services = [
    {
      title: 'Custom Web & Mobile App Development',
      description: 'Building high-performance, scalable applications using React Native, Next.js, and modern full-stack architectures.',
      icon: FaLaptopCode,
      color: 'text-primary',
      bg: 'bg-primary/10'
    },
    {
      title: 'UI/UX Design & Modernization',
      description: 'Creating premium, user-centric designs with modern aesthetics like glassmorphism and smooth animations to elevate brand identity.',
      icon: FaMobileAlt,
      color: 'text-accent-purple',
      bg: 'bg-accent-purple/10'
    },
    {
      title: 'Business Process Automation',
      description: 'Automating repetitive tasks and data extraction using Python and Selenium to increase operational efficiency.',
      icon: FaRobot,
      color: 'text-accent-cyan',
      bg: 'bg-accent-cyan/10'
    },
    {
      title: 'Advanced SEO & Technical Optimization',
      description: 'Optimizing web performance and implementing advanced SEO strategies like Hotel Schema and Open Graph for maximum visibility.',
      icon: FaSearchDollar,
      color: 'text-accent-rose',
      bg: 'bg-accent-rose/10'
    }
  ];

  return (
    <section id="services" className="section-padding bg-surface/50">
      <div className="container mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Premium <span className="text-gradient">Services</span>
          </h2>
          <p className="text-white/50 max-w-2xl mx-auto">
            Delivering cutting-edge digital solutions tailored for high-end freelance clients and businesses.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              whileHover={{ y: -10 }}
              className="p-8 glass rounded-[2rem] border-white/5 hover:border-white/10 transition-all group"
            >
              <div className={`w-16 h-16 rounded-2xl ${service.bg} ${service.color} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500`}>
                <service.icon size={32} />
              </div>
              <h3 className="text-2xl font-bold mb-4">{service.title}</h3>
              <p className="text-white/60 leading-relaxed">
                {service.description}
              </p>
              
              <div className="mt-8 flex items-center gap-2 text-sm font-bold tracking-widest uppercase text-white/20 group-hover:text-primary transition-colors">
                Explore Service <span className="w-8 h-[1px] bg-white/10 group-hover:bg-primary transition-all" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
